import PropTypes from "prop-types";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// routes
import { paths } from "src/routes/paths";
// redux
import { store } from "src/redux/store";
//
import { RECAPTCHA_KEY } from "src/config-global";
//
import { useAuthContext } from "../hooks";

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
    const { authenticated } = useAuthContext();

    const storedDestination = localStorage.getItem("storedDestination");

    // ----------------------------------

    useEffect(() => {
        store.dispatch({ type: "RESET" });

        return () => {
            // Remove reCAPTCHA script
            const script = document.getElementById("google-recaptcha-v3");
            if (script) script.remove();

            // Remove reCAPTCHA badge (if needed)
            const badge = document.querySelector(".grecaptcha-badge");
            if (badge) badge.remove();
        };
    }, []);

    if (authenticated) {
        if (storedDestination) {
            localStorage.removeItem("storedDestination"); // 确保只用一次
            //
            return <Navigate to={ `${ storedDestination }` } />;
        }
        //
        return <Navigate to={ `${ paths.dashboard.home }` } />;
    }

    return (
        <GoogleReCaptchaProvider reCaptchaKey={ RECAPTCHA_KEY } useRecaptchaNet>
            { children }
        </GoogleReCaptchaProvider>
    );
}

GuestGuard.propTypes = {
    children: PropTypes.node
};
